import {
  GET_SCHEME_LIST_SUCCESS,
  GET_SCHEME_LIST_FAIL,
  GET_SCHEMENAME_SUCCESS,
  GET_SCHEMENAME_FAIL,
  GET_SCHEMEANALYTE_SUCCESS,
  GET_SCHEMEANALYTE_FAIL,
  ADD_NEW_SCHEME_LIST_SUCCESS,
  ADD_NEW_SCHEME_LIST_FAIL,
  UPDATE_NEW_SCHEME_LIST_SUCCESS,
  UPDATE_NEW_SCHEME_LIST_FAIL,
  DELETE_SCHEME_SUCCESS,
  DELETE_SCHEME_FAIL,
  GET_PURCHASED_SCHEME_SUCCESS,
  GET_PURCHASED_SCHEME_FAIL,
  GET_COA_CRITERIA_LIST_SUCCESS,
  GET_COA_CRITERIA_LIST_FAIL,
  SUBMIT_COA_PARTICIPANTS_SUCCESS,
  SUBMIT_COA_PARTICIPANTS_FAIL,
  GET_COA_SUBMITTED_LIST_SUCCESS,
  GET_COA_SUBMITTED_LIST_FAIL,
  GET_STOCK_LIST_SUCCESS,
  GET_STOCK_LIST_FAIL,
  ADD_STOCK,
  ADD_STOCK_SUCCESS,
  ADD_STOCK_FAIL,
  UPDATE_STOCK,
  UPDATE_STOCK_SUCCESS,
  UPDATE_STOCK_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  SchemeList: [],
  AddUnits: [],
  SchemeAnalytes: [],
  PurchasedScheme: [],
  COACriteria: [],
  unit: [],
  error: {},
};

const SchemeList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SCHEME_LIST_SUCCESS:
      console.log("Data received in success action:", action.payload); // Log the action.payload
      return {
        ...state,
        SchemeList: action.payload,
      };

    case GET_SCHEME_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_SCHEMEANALYTE_SUCCESS:
      console.log("SCHEMEANALYTE:", action.payload); // Log the received data

      return {
        ...state,
        SchemeAnalyte: Array.isArray(action.payload?.data?.analytes)
          ? action.payload.data.analytes
          : [], // Extract analytes array
        error: null, // Clear any previous errors
      };

    case GET_SCHEMEANALYTE_FAIL:
      console.error("Failed to fetch scheme analyte:", action.payload);
      return {
        ...state,
        SchemeAnalyte: [], // Reset to empty array on failure
        error: action.payload || "Failed to fetch analyte data.", // Store the error message
      };

    /////analytes associated with units
    case GET_SCHEMENAME_SUCCESS:
      console.log("SCHEMENAME:", action.payload);
      return {
        ...state,
        SchemeAnalyte: action.payload, // Update to handle units array
      };

    case GET_SCHEMENAME_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_NEW_SCHEME_LIST_SUCCESS:
      return {
        ...state,
        AddUnits: [...state.AddUnits, action.payload.data],
      };

    case ADD_NEW_SCHEME_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case UPDATE_NEW_SCHEME_LIST_SUCCESS:
      return {
        ...state,
        SchemeList: state.SchemeList.map((unit) =>
          unit.id.toString() === action.payload.id.toString()
            ? { unit, ...action.payload }
            : unit,
        ),
      };

    case UPDATE_NEW_SCHEME_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_SCHEME_SUCCESS:
      return {
        ...state,
        unit: state.unit.filter(
          (person) => person.id.toString() !== action.payload.id.toString(),
        ),
      };

    case DELETE_SCHEME_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_PURCHASED_SCHEME_SUCCESS:
      console.log("Data received in success action:", action.payload);
      return {
        ...state,
        PurchasedScheme: action.payload, // ✅ Not SchemeList
      };
    case GET_PURCHASED_SCHEME_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case GET_COA_CRITERIA_LIST_SUCCESS:
      return {
        ...state,
        COACriteria: action.payload, // ✅ consistent key name
      };
    case GET_COA_CRITERIA_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case SUBMIT_COA_PARTICIPANTS_SUCCESS:
      return {
        ...state,
        coaSubmit: {
          loading: false,
          success: true,
          error: null,
          response: action.payload,
        },
      };

    case SUBMIT_COA_PARTICIPANTS_FAIL:
      return {
        ...state,
        coaSubmit: {
          loading: false,
          success: false,
          error: action.payload,
          response: null,
        },
      };
    case GET_COA_SUBMITTED_LIST_SUCCESS:
      return { ...state, submittedCOAList: action.payload || [] };

    case GET_COA_SUBMITTED_LIST_FAIL:
      return { ...state, submittedCOAList: [] };
    case GET_STOCK_LIST_SUCCESS:
      return { ...state, StockList: action.payload, loading: false };

    case GET_STOCK_LIST_FAIL:
      return { ...state, error: action.payload, loading: false };

    case ADD_STOCK:
      return { ...state, loading: true };

    case ADD_STOCK_SUCCESS:
      return {
        ...state,
        StockList: [action.payload, ...state.StockList],
        loading: false,
      };

    case ADD_STOCK_FAIL:
      return { ...state, error: action.payload, loading: false };

    case UPDATE_STOCK:
      return { ...state, loading: true };

    case UPDATE_STOCK_SUCCESS:
      return {
        ...state,
        StockList: state.StockList.map((stock) =>
          stock.id === action.payload.id ? action.payload : stock,
        ),
        loading: false,
      };

    case UPDATE_STOCK_FAIL:
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
};

export default SchemeList;
